import type {ChangeEvent} from 'react';
import {useState} from 'react';

import {userService} from '@/services/userService';
import type {AdminAfriexPerson} from '@/types';
import type {AfriexBlockReason} from '@/types/AfriexBlockReason';
import {nonBlockingReasons} from '@/types/AfriexBlockReason';
import {NoteUserState} from '@/types/Notes';
import {getErrorMessage} from '@/utils/errorMessage';
import {showErrorMessage} from '@/utils/showErrorMessage';
import {showSuccessMessage} from '@/utils/showSuccessMessage';

const useBlockUser = (user: AdminAfriexPerson) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showModal, setShowModal] = useState(false);
  const [securityNoteInput, setSecurityNoteInput] = useState<string>();
  const [blockReason, setBlockReason] = useState<string>();
  const [unblockReason, setUnblockReason] = useState<string>();

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const handleSecurityNoteChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => setSecurityNoteInput(e.target.value);

  const handleBlockReason = (val: string) => setBlockReason(val);
  const handleUnblockReason = (val: string) => setUnblockReason(val);

  const handleBlockUser = async () => {
    try {
      setIsLoading(true);

      if (nonBlockingReasons.includes(blockReason as AfriexBlockReason)) {
        await userService.createSecurityNote({
          user: user.id,
          note: securityNoteInput || '',
          reason: blockReason || '',
          userState: NoteUserState.NON_ACTION,
        });
      } else {
        await userService.blockUser(
          user.id,
          !!user.isSecurityFlagged,
          securityNoteInput || '',
          blockReason || '',
          unblockReason || '',
        );
      }
      const message = `Successfully ${
        user.isSecurityFlagged ? 'Unblocked' : 'Blocked'
      } user ${user.name.firstName} ${user.name.lastName}`;

      showSuccessMessage(message);
      toggleModal();
      setIsLoading(false);
      window.location.reload();
    } catch (e) {
      showErrorMessage(getErrorMessage(e, ''));
      setIsLoading(false);
    }
  };
  return {
    isLoading,
    showModal,
    toggleModal,
    handleSecurityNoteChange,
    securityNoteInput,
    handleBlockUser,
    handleBlockReason,
    blockReason,
    handleUnblockReason,
    unblockReason,
  };
};
export default useBlockUser;
